import type {CollectionSubType} from 'types';
import { CollectionSubTypes} from 'types';
import type {DataValue, VerifiedLinkedCatalogPostLink} from '../types';
import {isVerifiedLinkedCatalogPostLink} from './isVerifiedLinkedCatalogPostLink';

export const isVerifiedLinkedCollectionLink = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPostLink =>
  isVerifiedLinkedCatalogPostLink(link) &&
  CollectionSubTypes.includes(link.type as CollectionSubType);
